import React from "react";
import * as htmlToImage from "html-to-image";
export const useCopyElementToClipboard = (containerRef: React.RefObject<HTMLDivElement>) => {
    const handleCopyToClipboard = async () => {
        if (!containerRef.current) return;

        try {
            const blob = await htmlToImage.toBlob(containerRef.current, {
                cacheBust: true,
                backgroundColor: "#fff",
            });

            if (!blob) {
                console.error("Failed to create blob from element");
                return;
            }

            await navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob,
                }),
            ]);
        } catch (err) {
            console.error("Failed to copy image:", err);
        }
    };
    return {
        containerRef,
        handleCopyToClipboard,
    };
};
